import {React, observer, useEffect, useLocalStore} from '@api'
import {FilterGroup, FilterGroupItem, FilterItemDefinition, SimpleFilterItemDefinition, useFilterStore, useStores} from '@modules'
import {FilterGroupStore} from './FilterGroupStore'
import {OFFLINE_ID} from '@stores'

export const OFFLINE_FILTER_VALUE_ID = 'offline'
export const ONLINE_FILTER_VALUE_ID = 'online'

export const OfflineItemsFilterGroup = observer<{}, HTMLDivElement>(({}, ref) => {
  const {catalog: {_filterOfflineItems,offlineItemsOfCurrentWorkspace,onlineItemCount}, catalog} = useStores(),
    filter = useFilterStore(),
    offlineItemCount=_filterOfflineItems(OFFLINE_ID,offlineItemsOfCurrentWorkspace,"",false).length,
    {state: {groups, section, search}, localSearchRegex} = filter,
    group = OFFLINE_ID,
    items: SimpleFilterItemDefinition[] = [{count: onlineItemCount, name: 'No', id: ONLINE_FILTER_VALUE_ID, compoundId: ONLINE_FILTER_VALUE_ID, label: 'No', type: 'Boolean'}, {count: offlineItemCount, name: 'Yes', id: OFFLINE_FILTER_VALUE_ID, compoundId: OFFLINE_FILTER_VALUE_ID, label: 'Yes', type: 'Boolean'}],
    {group: groupState} = useLocalStore(() => new FilterGroupStore<{}, SimpleFilterItemDefinition>(filter, group, () => null, ({group: {selected}}) => {
      items.forEach(item => {
        if (selected.has(item.id)) {
          selected.set(item.id, item)
        }
      })
    }))

  const noSearchResults = search && !items.some(({name}) => name.match(localSearchRegex))

  useEffect(() => {
    groupState.noSearchResults = noSearchResults || noSearchResults === undefined
  }, [noSearchResults])

  useEffect(() => {
    groupState.groupedByValue = _.keyBy<SimpleFilterItemDefinition>(items, item => item.id as string)
  }, [items])

  if (noSearchResults) return null
  return (!section || section == catalog.workspaceConfig?._id) && (offlineItemCount > 0 || groupState.selected.size > 0 || groupState.excluded.size > 0) ? (
    <FilterGroup group={group}
                 ref={ref as any}
                 title='Pending Item?'
                 count={2}
                 >
      {items.map((item, i) => {
        const {name, id, count} = item
        return <FilterGroupItem
          name={name} key={i}
          checked={groupState.selected?.has(id)}
          count={count}
          item={item}
          group={group}
          excluded={groupState.excluded.has(id) || groupState.excluded.has(id.toString())}
        />
      })}
    </FilterGroup>) : null
}, {forwardRef: true})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/filters/components/internal/OfflineItemsFilterGroup.tsx